<template>
  <div data-testid="articleColumn" :class="[multiColumnLayout ? 'md:max-w-[560px]' : 'md:max-w-[752px]', 'relative md:mx-auto']">
    <template v-for="(content, index) in column.contents" :key="`${content.fieldId}-${index}`">
      <template v-if="content.fieldId === 'itineraryParts'">
        <div class="p-2">
          <div class="border-l-[0.5px]" :class="theme === 'dark' ? 'border-dark-bd-default' : 'border-light-bd-default'">
            <template v-for="(itineraryPart, index) in content.itineraryParts" :key="index">
              <CustomPartComponent :content="itineraryPart" :experiences="experiences" :for-itinerary="true" :on-cta-link-click="onCtaLinkClick" />
            </template>
          </div>
        </div>
      </template>

      <template v-else-if="content.fieldId === 'ctaButton'">
        <div class="py-4 md:mx-auto md:max-w-[368px]">
          <AtomsPrimaryButton :on-click="() => onClickCtaButton(content.link)" :theme="theme">{{ content.label }} </AtomsPrimaryButton>
        </div>
      </template>

      <template v-else-if="content.fieldId === 'drawerLink'">
        <div v-if="showDrawerLink" class="pb-6 pt-1">
          <DrawerLinkButton :label="content.label" :on-click="() => onDrawerLinkClick?.(content.tabKey, content.label)" />
        </div>
      </template>

      <template v-else>
        <CustomPartComponent :content="content" :experiences="experiences" :multi-column-layout="multiColumnLayout" :on-cta-link-click="onCtaLinkClick" />
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import CustomPartComponent from '@/wabunka-src/common/features/Featured/components/ArticleColumn/CustomPartComponent/CustomPartComponent.vue';
import DrawerLinkButton from '@/wabunka-src/common/features/Featured/components/DrawerLinkButton/DrawerLinkButton.vue';
import { ThemeKey } from '@/wabunka-src/common/features/Featured/injectionKeys';
import type { ArticleColumn } from '@/wabunka-src/common/features/Featured/models/featured/featured';
import { type ExperienceListViewModel } from '@/wabunka-src/features/Experience';

const props = withDefaults(
  defineProps<{
    column: ArticleColumn;
    experiences: ExperienceListViewModel;
    multiColumnLayout?: boolean;
    /**
     * CTA ボタンクリック時に呼ばれる。true を返すと遷移を行わない。
     */
    onCtaLinkClick?: (link: string) => boolean;
    /**
     * drawerLink を描画するか。表示可能なドロワータブが無いページでは false（ADR-145 / D-005）。
     */
    showDrawerLink?: boolean;
    /**
     * drawerLink クリック時に呼ばれる。開くタブのキーと、押されたリンクのラベルを親へ渡す。
     */
    onDrawerLinkClick?: (tabKey: string, label: string) => void;
  }>(),
  { multiColumnLayout: false, onCtaLinkClick: undefined, showDrawerLink: false, onDrawerLinkClick: undefined },
);

const theme = inject(ThemeKey, ref<'light' | 'dark'>('light'));

const onClickCtaButton = (link: string) => {
  if (props.onCtaLinkClick?.(link)) {
    return;
  }
  navigateTo(link, {
    external: false,
    open: { target: '_self' },
  });
};
</script>
